import React from "react";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/styles";
import { ButtonBlockDark } from "components/ui";
import linkResolver from "utils/linkResolver";

const styles = theme => ({
  bgImageWrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px",
    minHeight: "150px",
    height: "auto",
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      height: "385px"
    }
  }
});

function WidescreenImageBlock(props) {
  const { data, fields, classes } = props;
  return (
    <Container maxWidth={false}>
      <div
        className={classes.bgImageWrapper}
        style={{ backgroundImage: `url(${data.image.url})` }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)"
          }}
        />
        {data.title && (
          <Box style={{ position: "relative", zIndex: 1 }}>
            <Typography component="p" variant="h4" color="secondary">
              {data.title[0].text}
            </Typography>
          </Box>
        )}
        {fields && (
          <Box pt={data.title ? "6" : 0} display="flex" flexDirection="row">
            {fields.map((item, key) => (
              <React.Fragment key={key}>
                {item.link_title && item.link && (
                  <Box px={4}>
                    <ButtonBlockDark
                      text={item.link_title[0].text}
                      link={
                        item.link._meta ? linkResolver(item.link._meta) : ""
                      }
                    />
                  </Box>
                )}
              </React.Fragment>
            ))}
          </Box>
        )}
      </div>
    </Container>
  );
}

WidescreenImageBlock.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired
};

export default withStyles(styles)(WidescreenImageBlock);
